export const pagesEquipmentEn = {
  add: {
    pageTitle: 'Add Equipment',
    progressbar: {
      fieldsCompleted: 'Completed',
      fieldsTotal: 'Total',
      filled: 'Completed',
      left: '{{value}} fields remaining',
      modeSetting: 'Input Mode',
      mustItem: 'Required Fields',
      mustItemOnly: 'Required fields only',
      progressCircle: 'Progress Circle',
      title: 'Progress',
      total: 'All Fields'
    },
    step1: {
      controlType: {
        label: 'Management Method',
        options: {
          distributionLogManagement: 'Distribution Log Management',
          inventoryManagement: 'Inventory Management',
          unmanaged: 'Unmanaged'
        }
      },
      description: 'Enter basic information about the equipment',
      equipmentItem: {
        label: 'Equipment Item',
        placeholder: 'Select equipment item'
      },
      equipmentItemName: {
        label: 'Equipment Item',
        placeholder: 'Select equipment item'
      },
      equipmentType: {
        label: 'Equipment Type',
        placeholder: 'Select equipment type'
      },
      equipmentTypeName: {
        label: 'Equipment Type',
        placeholder: 'Select equipment type'
      },
      isControlTarget: {
        label: 'Subject to Equipment Management'
      },
      isManagementTarget: {
        label: 'Subject to equipment management'
      },
      mustOnly: {
        label: 'Enter required fields only'
      },
      name: {
        label: 'Equipment Name',
        placeholder: 'e.g., MacBook Pro 13-inch'
      },
      nextButton: 'Next: Identification',
      purchaseDate: {
        label: 'Purchase Date'
      },
      purchaseMethod: {
        label: 'Purchase Method',
        placeholder: 'Select purchase method'
      },
      purchaseRequestNumber: {
        label: 'Purchase Request Number',
        placeholder: 'e.g., PUR-2024-001'
      },
      remarks: {
        label: 'Remarks',
        placeholder: 'Enter remarks'
      },
      supplier: {
        label: 'Supplier',
        placeholder: 'e.g., Apple Store'
      },
      title: 'Basic Information',
      unit: {
        label: 'Equipment Unit'
      },
      unitPrice: {
        label: 'Equipment Unit Price',
        placeholder: 'e.g., 150000'
      },
      unitPriceCurrency: {
        label: 'Currency'
      }
    },
    step2: {
      assetTag: {
        label: 'Asset Management Number / Asset Tag',
        placeholder: 'e.g., AS-2024-001'
      },
      controlType: {
        label: 'Control Type',
        options: {
          DISTRIBUTION_LOG_MANAGEMENT: 'Distribution Log Management',
          INVENTORY_MANAGEMENT: 'Inventory Management',
          UNMANAGED: 'Unmanaged'
        },
        placeholder: 'Select control type'
      },
      inventoryId: {
        label: 'Equipment/Consumable Management ID',
        placeholder: 'e.g., INV-2024-001'
      },
      manufactureDate: {
        label: 'Manufacture Date'
      },
      manufacturer: {
        label: 'Manufacturing Company',
        placeholder: 'e.g., Apple'
      },
      modelName: {
        label: 'Model Name',
        placeholder: 'e.g., MacBook Pro 14-inch'
      },
      modelNumber: {
        label: 'Model Number',
        placeholder: 'e.g., A2338'
      },
      nextButton: 'Next: Assignment',
      productName: {
        label: 'Product Name',
        placeholder: 'e.g., MacBook Pro'
      },
      serialNumber: {
        label: 'Serial Number',
        placeholder: 'e.g., C02XX1234567'
      },
      title: 'Identification'
    },
    step3: {
      assignedWorker: {
        label: 'Assignee / User Name',
        placeholder: 'Select assignee / user name'
      },
      assignmentStartDate: {
        label: 'Assignment Start Date'
      },
      expectedReturnDate: {
        label: 'Scheduled End Date'
      },
      nextButton: 'Next: Placement',
      skipButton: 'Skip',
      skipInfo: 'If there is no assignee, click "Skip"',
      title: 'Assignment Information',
      usageAgreementSigned: {
        label: 'Usage Agreement Signed'
      },
      usagePlace: {
        label: 'Usage Location',
        placeholder: 'Select usage location'
      },
      usageRestrictions: {
        label: 'Usage Restrictions',
        placeholder: 'Enter any usage restrictions'
      },
      usageType: {
        label: 'Usage Type',
        options: {
          homeUse: 'Home Use',
          personalLoan: 'Personal Loan',
          sharedUse: 'Shared Use',
          shortTermLoan: 'Short-term Loan'
        },
        placeholder: 'Select usage type'
      }
    },
    step4: {
      areaName: {
        label: 'Area Name',
        placeholder: 'e.g., Meeting Room A'
      },
      deskSeatNumber: {
        label: 'Seat Number/Desk Number',
        placeholder: 'e.g., D-101'
      },
      expectedRemovalDate: {
        label: 'Scheduled End Date'
      },
      gpsOrBleTagNo: {
        label: 'GPS/BLE Tag ID',
        placeholder: 'e.g., TAG-2024-001'
      },
      labelStickerNo: {
        label: 'Equipment Sticker Number',
        placeholder: 'e.g., LS-2024-001'
      },
      lastPhysicalCheckDate: {
        label: 'Last Physical Check Date'
      },
      nextButton: 'Next: Storage',
      physicalEnvironment: {
        label: 'Physical Environment',
        placeholder: 'Enter dimensions, environmental conditions, etc.'
      },
      place: {
        label: 'Installation Location',
        placeholder: 'Select installation location',
        searchPlaceholder: 'Search by location name'
      },
      placementDate: {
        label: 'Installation Date'
      },
      placementDetails: {
        title: 'Installation Details'
      },
      placementDocumentLink: {
        label: 'Placement Document Link',
        placeholder: 'e.g., https://example.com/doc'
      },
      placementNotes: {
        label: 'Installation Notes',
        placeholder: 'Enter notes about the installation'
      },
      placementType: {
        label: 'Installation Type',
        options: {
          fixed: 'Fixed',
          free: 'Free',
          inStorage: 'In Storage',
          mobile: 'Mobile'
        },
        placeholder: 'Select installation type'
      },
      placementVerificationStatus: {
        label: 'Installation Verification Status',
        options: {
          mismatch: 'Mismatch',
          ok: 'OK',
          unverified: 'Unverified'
        },
        placeholder: 'Select verification status'
      },
      reasonForPlacement: {
        label: 'Reason for Installation',
        placeholder: 'Enter reason for installation'
      },
      shelfCabinetNumber: {
        label: 'Shelf/Cabinet Number',
        placeholder: 'e.g., S-A-01'
      },
      skipButton: 'Skip',
      skipInfo: 'If there is no placement location, click "Skip"',
      title: 'Placement Information',
      verificationMethod: {
        label: 'Verification Method',
        options: {
          photoRecord: 'Photo Record',
          physicalCheck: 'Physical Check',
          scan: 'Scan'
        },
        placeholder: 'Select verification method'
      }
    },
    step6: {
      failure: {
        description: 'Enter information if any failure has occurred',
        failureDate: 'Failure Date',
        failureDatePlaceholder: 'Select failure date',
        failureDescPlaceholder: 'Please describe the failure symptoms in detail',
        failureDescription: 'Failure Content/Symptoms',
        incidentFailureId: 'Incident/Failure ID',
        incidentIdPlaceholder: 'e.g., INC-2024-001',
        title: 'Failure Information'
      },
      inputError: 'There are errors in your input. Please check each step.',
      repair: {
        completedDatePlaceholder: 'Select repair completed date',
        description: 'Enter information about repair response',
        maintenanceNotes: 'Maintenance Notes',
        notesPlaceholder: 'Enter any maintenance notes or precautions',
        repairCompletedDate: 'Repair Completed Date',
        repairCost: 'Repair Cost',
        repairCostPlaceholder: 'e.g., 30000',
        repairRequestDate: 'Repair Request Date',
        requestDatePlaceholder: 'Select repair request date',
        technicianPlaceholder: 'e.g., Apple Support',
        technicianVendor: 'Technician/Vendor',
        title: 'Repair Information'
      },
      submitButton: 'Register',
      submitError: 'Registration failed. Please try again.',
      submitSuccess: 'Equipment registered (ID: {{equipmentId}})',
      submitting: 'Registering...',
      summary: {
        assetId: 'Asset ID',
        assignedTo: 'Assignee',
        name: 'Equipment Name',
        place: 'Installation Location',
        title: 'Registration Details'
      },
      title: 'Failure & Repair'
    },
    stepAcquisition: {
      nextButton: 'Next: Failure & Repair',
      operation: {
        description: 'Enter information about the equipment operation status',
        operationalStatus: 'Operational Status',
        operationalStatusOptions: {
          active: 'Active',
          onLoan: 'On Loan',
          stopped: 'Stopped'
        },
        plannedReturnDate: 'Planned Return Date',
        plannedReturnPlaceholder: 'Select planned return date',
        statusPlaceholder: 'Select operational status',
        title: 'Operation & Usage',
        usageStartDate: 'Usage Start Date',
        usageStartPlaceholder: 'Select usage start date'
      },
      purchase: {
        assetId: 'Asset ID (Management Number)',
        assetIdPlaceholder: 'e.g., AST-2024-001',
        description: 'Enter information about the equipment purchase and introduction',
        maintenanceContractId: 'Maintenance Contract ID',
        maintenanceContractPlaceholder: 'e.g., MC-2024-001',
        purchaseCost: 'Purchase Cost',
        purchaseCostPlaceholder: 'e.g., 150000',
        purchaseDate: 'Purchase Date',
        purchaseDatePlaceholder: 'Select purchase date',
        title: 'Purchase & Introduction',
        vendorPlaceholder: 'e.g., Apple Store',
        vendorSupplierName: 'Vendor/Supplier Name',
        warrantyExpiryDate: 'Warranty Expiry Date',
        warrantyExpiryPlaceholder: 'Select warranty expiry date',
        warrantyStartDate: 'Warranty Start Date',
        warrantyStartPlaceholder: 'Select warranty start date'
      },
      title: 'Operations & Maintenance'
    },
    stepWarehousing: {
      expiryDate: {
        label: 'Planned Storage End Date'
      },
      nextButton: 'Next: Acquisition',
      place: {
        label: 'Storage Location',
        placeholder: 'Select storage location'
      },
      startDate: {
        label: 'Storage Start Date'
      },
      title: 'Storage'
    },
    stepper: {
      acquisition: 'Acquisition & Operations',
      assignment: 'Assignment',
      basic: 'Basic Information',
      identification: 'Identification',
      maintenance: 'Failure & Repair',
      other: 'Other',
      placement: 'Placement',
      warehousing: 'Storage'
    },
    title: 'Add Equipment',
    validation: {
      assignmentStartDateRequired: 'Assignment start date is required',
      controlTypeRequired: 'Management method is required',
      equipmentItemRequired: 'Equipment item is required',
      equipmentTypeRequired: 'Equipment type is required',
      expectedRemovalDateInvalid: 'Scheduled end date must be on or after installation date',
      nameRequired: 'Equipment name is required',
      returnDateInvalid: 'Scheduled end date must be after assignment start date',
      warehousingExpiryDateInvalid: 'Planned storage end date must be on or after the storage start date'
    },
    workerSearch: {
      placeholder: 'Search for worker'
    }
  },
  addSelect: {
    body: {
      equipmentAndConsumables: 'Equipment & Consumables',
      fillOutDetails: 'Fill out details',
      itemCard: {
        equipmentItem: 'Equipment Item',
        equipmentName: 'Equipment & Consumables Name',
        equipmentType: 'Equipment Type',
        requiredDetails: 'Required fields'
      },
      selectEquipmentType: 'Select what you want to add'
    },
    header: {
      headerTitle: 'Add Equipment & Consumables'
    },
    options: {
      bulkCsvUpload: {
        button: 'Upload CSV',
        description: 'You can add data for multiple equipment, up to 500 records at a time. A CSV file following the DRESS CODE format is required.',
        selectedEquipmentType: 'Selected type:',
        title: 'Bulk upload via CSV'
      },
      description: 'Or...',
      syncIT: 'Sync with External System'
    }
  },
  alerts: {
    helpToggle: {
      REPLACEMENT_DUE: {
        body: 'Equipment and consumables that have exceeded their period and need replacement.',
        title: 'What is Replacement due?'
      }
    },
    missingReferenceDateDescription: '{{count}} equipment items are missing a reference date for period rule calculation.',
    missingReferenceDateTitle: 'Missing Reference Date',
    searchPlaceholder: 'Search equipment / items…',
    sidebar: {
      closeSideTab: 'Close side tab',
      collectionDue: 'Collection Due',
      inventoryCheckDue: 'Inventory Check Due',
      lendingDue: 'Lending Due',
      openSideTab: 'Open',
      placementDue: 'Placement Due',
      replacementDue: 'Replacement Due',
      shortage: 'Shortage',
      title: 'Alert Categories'
    },
    viewMode: {
      individual: 'Individual',
      item: 'By Item'
    }
  },
  detail: {
    actions: {
      addMaintenanceRecord: 'Add Maintenance Record',
      changeStatus: 'Change Status',
      removeAssignment: 'Remove Assignment'
    },
    changeStatusDialog: {
      cancel: 'Cancel',
      confirm: 'Change Status',
      currentStatus: 'Current Status',
      description: 'Change the status of "{{name}}" from {{currentStatus}} to a new status.',
      error: 'Failed to change equipment status.',
      newStatus: 'New Status',
      required: 'Required',
      selectStatus: 'Select new status',
      success: 'Status has been changed successfully.',
      title: 'Change Status',
      unsavedWarning: 'You have unsaved changes. Changing the status will discard them. Do you want to continue?',
      unsavedWarningContinue: 'Continue',
      unsavedWarningTitle: 'Unsaved Changes'
    },
    fields: {
      accountingDeregistrationDate: 'Deregistration Processing Date',
      actualReturnDate: 'Actual Return Date',
      addAssignment: 'Add Assignment',
      assetManagementNumber: 'Asset Management Number',
      assetTag: 'Asset Tag',
      assetWriteOffReason: 'Deregistration Reason',
      assignedWorkerId: 'Assignee',
      assignmentStartDate: 'Assignment Start Date',
      controlType: 'Control Type',
      currentAssignment: 'Current Assignment',
      deskSeatNumber: 'Seat Number/Desk Number',
      disposalCertificateAttached: 'Disposal Certificate Attached',
      disposalDate: 'Disposal Date',
      disposalDecisionDate: 'End of Operation Date',
      disposalMethod: 'Disposal Method',
      endOfLifeType: 'End of Life Type',
      equipmentId: 'Equipment ID',
      equipmentItem: 'Equipment Item',
      equipmentName: 'Equipment Name',
      equipmentRelationType: 'Equipment Relation Type',
      equipmentStatus: 'Equipment Status',
      equipmentStickerNumber: 'Equipment Sticker Number',
      equipmentType: 'Equipment Type',
      expectedRemovalDate: 'Scheduled End Date',
      expectedReturnDate: 'Scheduled End Date',
      failureDetails: 'Failure Content/Symptoms',
      failureOccurredDate: 'Failure Occurred Date',
      gpsOrBleTagId: 'GPS/BLE Tag ID',
      gpsOrBleTagNo: 'GPS/BLE Tag ID',
      incidentFailureId: 'Incident/Failure ID',
      inventoryId: 'Equipment/Consumable Management ID',
      isControlTarget: 'Is Control Target',
      lastPhysicalCheckDate: 'On-site Verification Date',
      maintenanceContractId: 'Maintenance Contract ID',
      maintenanceHistory: 'Maintenance History',
      maintenanceId: 'Maintenance ID',
      maintenanceNotes: 'Maintenance Notes',
      manufactureDate: 'Manufacture Date',
      manufacturer: 'Manufacturing Company',
      modelNumber: 'Model Number',
      noAssignment: 'No assignment',
      noMaintenanceHistory: 'No maintenance history',
      operationalStatus: 'Operational Status',
      physicalEnvironment: 'Installation Location Dimensions/Conditions',
      placementAreaName: 'Area Name',
      placementBuildingName: 'Building Name',
      placementDate: 'Installation Date',
      placementDocumentLink: 'Installation Related Documents',
      placementFloorNumber: 'Floor Number',
      placementLastUpdated: 'Last Updated Date',
      placementLocationName: 'Location Name',
      placementNotes: 'Installation Notes',
      placementPhotoUrl: 'Installation Photo URL',
      placementPlace: 'Installation Site',
      placementPlaceId: 'Installation Location',
      placementRemarks: 'Installation Remarks',
      placementStatus: 'Current Installation Status',
      placementType: 'Installation Type',
      placementVerificationMethod: 'Installation Verification Method',
      placementVerificationStatus: 'Installation Verification Status',
      plannedReturnDate: 'Planned Return Date',
      productName: 'Product Name',
      purchaseDate: 'Purchase Date',
      purchasePrice: 'Purchase Price',
      purchaseVendor: 'Purchase Source/Vendor Name',
      reasonForPlacement: 'Installation Reason',
      registeredByWorkerId: 'Registered By',
      remarks: 'Remarks',
      repairCompletedDate: 'Repair Completed Date',
      repairCost: 'Repair Cost',
      repairRequestedDate: 'Repair Requested Date',
      replacementEquipmentId: 'Replacement Equipment ID',
      selectPerson: 'Select Person',
      serialNumber: 'Serial Number',
      shelfCabinetNumber: 'Shelf/Storage Cabinet Number',
      technicianVendor: 'Repair Responsible Worker',
      transfereePersonId: 'Supply Recipient',
      unit: 'Equipment Unit',
      unitPrice: 'Unit Price',
      unitPriceCurrency: 'Currency',
      usageAgreementSigned: 'Usage Agreement Signed',
      usageLocation: 'Usage Location',
      usageResponsiblePerson: 'Usage Responsible Person',
      usageRestrictions: 'Usage Restrictions',
      usageStartDate: 'Usage Start Date',
      usageStatus: 'Usage Status',
      usageType: 'Usage Type',
      warehousingExpiryDate: 'Planned Storage End Date',
      warehousingPlace: 'Storage Site',
      warehousingPlaceId: 'Storage Location',
      warehousingStartDate: 'Storage Start Date',
      warrantyExpiryDate: 'Warranty Expiry Date',
      warrantyStartDate: 'Warranty Start Date',
      wipeMethod: 'Data Erasure Method'
    },
    header: {
      assignmentStartLabel: 'Assignment',
      placementStartLabel: 'Placement'
    },
    messages: {
      maintenanceHistoryCount: '{{count}} maintenance records'
    },
    options: {
      boolean: {
        no: 'No',
        yes: 'Yes'
      },
      controlType: {
        DISTRIBUTION_LOG_MANAGEMENT: 'Distribution Log Management',
        INVENTORY_MANAGEMENT: 'Inventory Management',
        UNMANAGED: 'Unmanaged'
      },
      disposalMethod: {
        PHYSICAL_DESTRUCTION: 'Physical Destruction',
        RECYCLING: 'Recycling',
        VENDOR_REQUEST: 'Vendor Request'
      },
      endOfLifeType: {
        DISPOSED: 'Disposed',
        INITIAL_DEFECT: 'Initial defect',
        LOST: 'Lost',
        OTHER: 'Other',
        SOLD: 'Sold',
        TRANSFERRED: 'Transferred'
      },
      equipmentStatus: {
        ASSIGNED: 'Assigned',
        AVAILABLE: 'Available',
        DECOMMISSIONED: 'Decommissioned',
        PLACED: 'Placed',
        UNDER_REPAIR: 'Under Repair'
      },
      itemType: {
        CONSUMABLE: 'Consumable',
        LOANABLE: 'Loanable',
        TRANSFERABLE: 'Transferable'
      },
      operationalStatus: {
        ACTIVE: 'Active',
        ON_LOAN: 'On Loan',
        STOPPED: 'Stopped'
      },
      placementStatus: {
        IN_USE: 'In Use',
        MOVING: 'Moving',
        NOT_PLACED: 'Not Placed',
        STORED: 'Stored',
        TO_BE_DISPOSED: 'To Be Disposed'
      },
      placementType: {
        FIXED: 'Fixed',
        FREE: 'Free',
        MOVING: 'Moving',
        STORED: 'Stored'
      },
      placementVerificationStatus: {
        MISMATCH: 'Mismatch',
        OK: 'OK',
        UNVERIFIED: 'Unverified'
      },
      usageStatus: {
        DISPOSED: 'Disposed',
        IN_USE: 'In Use',
        RETURNED: 'Returned',
        SCHEDULED_FOR_LENDING: 'Scheduled for Lending',
        STORED: 'Stored',
        UNDER_REPAIR: 'Under Repair'
      },
      usageType: {
        PERSONAL_ASSIGNMENT: 'Personal Assignment',
        SHARED_USE: 'Shared Use',
        SHORT_TERM_LENDING: 'Short-term Lending',
        WORK_FROM_HOME: 'Work from Home'
      },
      verificationMethod: {
        PHOTO_RECORD: 'Photo Record',
        PHYSICAL_CHECK: 'Physical Check',
        SCAN: 'Scan'
      },
      wipeMethod: {
        DOD_STANDARD: 'DOD Standard',
        ENCRYPTION_DELETION: 'Encryption Deletion',
        PHYSICAL_DESTRUCTION: 'Physical Destruction'
      }
    },
    pageTitle: 'Equipment Details',
    sections: {
      equipmentAssignment: 'Assignment',
      equipmentIdInfo: 'ID Information',
      equipmentPlacement: 'Installation',
      equipmentWarehousing: 'Storage',
      maintenanceRepair: 'Maintenance/Repair',
      procurementAcquisition: 'Procurement/Acquisition',
      retirementDisposal: 'End of Operation',
      usageOperation: 'Usage/Operation'
    },
    tabs: {
      lifecycle: 'Lifecycle',
      profile: 'Profile',
      status: 'Status'
    },
    validation: {
      expectedRemovalDateInvalid: 'Scheduled end date must be on or after installation date',
      expectedReturnDateInvalid: 'Scheduled end date must be on or after assignment start date',
      warehousingExpiryDateInvalid: 'Planned storage end date must be on or after the storage start date'
    }
  },
  importCsv: {
    checkValidColumn: {
      errors: 'Errors',
      warnings: 'Warnings'
    },
    completeDialog: {
      button: 'Go to Equipment List'
    },
    prepareCsvFile: {
      templateTitle: 'Equipment Template',
      updateExisting: 'Update existing data'
    },
    title: 'Equipment CSV Import',
    unit: 'items'
  },
  items: {
    active: 'Active',
    alerts: 'Alerts',
    allTypes: 'All',
    closeSideTab: 'Close side tab',
    equipmentTypeFilter: 'Equipment type filter',
    inactive: 'Inactive',
    inventory: 'Inventory',
    notFound: 'Item not found',
    openSideTab: 'Open',
    pageTitle: 'Items',
    profile: 'Profile',
    ruleAndPolicy: 'Rule & Policy',
    searchPlaceholder: 'Search items...',
    total: 'Total'
  },
  list: {
    addEquipment: 'Add Equipment',
    csv: {
      headers: {
        assetTag: 'Asset Tag',
        assignedPerson: 'Assignee',
        assignedPlace: 'Installation Location',
        createdAt: 'Created At',
        equipmentType: 'Type',
        id: 'ID',
        name: 'Name',
        serialNumber: 'Serial Number'
      },
      missingDownloadUrl: 'The download link for the CSV export could not be obtained. Please try again later.'
    },
    filterPlaceholder: 'Search equipment...',
    filters: {
      assignedWorker: 'Assignee',
      equipmentItem: 'Equipment Item',
      equipmentType: 'Equipment Type',
      itemType: 'Item type',
      itemTypePlaceholder: 'Search item types…',
      placementPlace: 'Installation Site',
      warehousingPlace: 'Storage Site'
    },
    pageTitle: 'Equipment',
    table: {
      headers: {
        assetTag: 'Asset Management Number/Asset Tag',
        assignedPerson: 'Assignee',
        assignedPlace: 'Installation Location',
        createdAt: 'Created At',
        equipment: 'Equipment',
        equipmentType: 'Type',
        serialNumber: 'Serial Number'
      }
    },
    tableLoadError: 'Failed to load the list. Please reload the page.',
    tabs: {
      all: 'All',
      assigned: 'Assigned',
      available: 'Available',
      decommissioned: 'Decommissioned',
      placed: 'Placed',
      underRepair: 'Under Repair'
    }
  },
  ruleAndPolicy: {
    contextHeader: 'Individual Settings : Period',
    individualSettings: 'Individual Settings',
    loadError: 'Failed to load period rule. Please reload the page.',
    saveError: 'Failed to save period rule.',
    saveSuccess: 'Period rule saved.',
    sideMenu: {
      closeSideTab: 'Close side tab',
      openSideTab: 'Open',
      periodRule: 'Period Rule',
      replacement: 'Replacement'
    },
    validation: {
      templateRequired: 'Select a template preset'
    }
  },
  settings: {
    equipmentItems: {
      addEquipmentItem: 'Add Equipment Item',
      description: 'Manage equipment subcategories',
      disableDialog: {
        cancel: 'Cancel',
        confirm: 'Disable',
        description: 'Are you sure you want to disable "{{name}}"?',
        error: {
          description: 'Failed to disable the item.',
          title: 'Error'
        },
        success: {
          description: '"{{name}}" has been disabled.',
          title: 'Item Disabled'
        },
        title: 'Disable Item'
      },
      editEquipmentItem: 'Edit {{name}}',
      editPresetEquipmentItem: 'Edit {{name}} (Preset)',
      enableDialog: {
        cancel: 'Cancel',
        confirm: 'Enable',
        description: 'Are you sure you want to enable "{{name}}"?',
        error: {
          description: 'Failed to enable the item.',
          title: 'Error'
        },
        success: {
          description: '"{{name}}" has been enabled.',
          title: 'Item Enabled'
        },
        title: 'Enable Item'
      },
      form: {
        description: {
          description: 'Enter a description for this equipment item.',
          label: 'Description',
          placeholder: 'Purpose and features of this equipment item'
        },
        displayOrder: {
          description: 'If no display order is entered, the default value 0 will be set.',
          label: 'Display Order',
          placeholder: '1'
        },
        equipmentType: {
          label: 'Equipment Type',
          placeholder: 'Select type'
        },
        error: {
          saveFailed: 'Failed to save the equipment item.'
        },
        itemType: {
          description: 'Select how this item is tracked: loanable, transferable, or consumable.',
          label: 'Item type',
          options: {
            CONSUMABLE: {
              description: 'Track inventory levels by item only.',
              label: 'Consumable'
            },
            LOANABLE: {
              description: 'Track assignment and placement per unit.',
              label: 'Loanable'
            },
            TRANSFERABLE: {
              description: 'Track recipient per unit.',
              label: 'Transferable'
            }
          },
          required: 'Please select an item type.'
        },
        name: {
          label: 'Name',
          placeholder: ''
        }
      },
      searchPlaceholder: 'Search equipment items...',
      showDeactivated: 'Show disabled items',
      table: {
        description: 'Description',
        displayOrder: 'Display Order',
        equipmentType: 'Equipment Type',
        itemType: 'Item type',
        name: 'Item Name'
      },
      title: 'Equipment Items'
    },
    equipmentTypes: {
      addEquipmentType: 'Add Equipment Type',
      categories: {
        CONFERENCE_EQUIPMENT: 'Conference Room Equipment',
        CONSUMABLES: 'Consumables',
        EXHIBITION_DEMO_EQUIPMENT: 'Exhibition & Demo Equipment',
        OFFICE_FURNITURE: 'Office Furniture',
        OTHER: 'Other',
        PERIPHERAL_DEVICES: 'PC Peripherals',
        PERSONAL_OFFICE_EQUIPMENT: 'Personal Office Equipment',
        RESEARCH_LABORATORY_EQUIPMENT: 'Research & Lab Equipment',
        TOOLS_MEASURING_EQUIPMENT: 'Tools & Measuring Equipment'
      },
      description: 'Manage equipment categories',
      disableDialog: {
        cancel: 'Cancel',
        confirm: 'Disable',
        description: 'Are you sure you want to disable "{{name}}"?',
        error: {
          description: 'Failed to disable the item.',
          title: 'Error'
        },
        success: {
          description: '"{{name}}" has been disabled.',
          title: 'Item Disabled'
        },
        title: 'Disable Item'
      },
      editEquipmentType: 'Edit {{name}}',
      enableDialog: {
        cancel: 'Cancel',
        confirm: 'Enable',
        description: 'Are you sure you want to enable "{{name}}"?',
        error: {
          description: 'Failed to enable the item.',
          title: 'Error'
        },
        success: {
          description: '"{{name}}" has been enabled.',
          title: 'Item Enabled'
        },
        title: 'Enable Item'
      },
      form: {
        category: {
          label: 'Category',
          placeholder: 'Select category'
        },
        description: {
          description: 'Enter a description for this equipment type.',
          label: 'Description',
          placeholder: 'Purpose and features of this equipment type'
        },
        displayOrder: {
          description: 'If no display order is entered, the default value 0 will be set.',
          label: 'Display Order',
          placeholder: '1'
        },
        error: {
          saveFailed: 'Failed to save the equipment type.'
        },
        name: {
          label: 'Name',
          placeholder: ''
        }
      },
      searchPlaceholder: 'Search equipment types...',
      showDeactivated: 'Show disabled items',
      table: {
        category: 'Category',
        description: 'Description',
        displayOrder: 'Display Order',
        name: 'Type Name'
      },
      title: 'Equipment Types'
    },
    shared: {
      DeleteDialog: {
        cancelButton: 'Cancel',
        description: 'If "{{name}}" is in use, the master name cannot be deleted. This operation cannot be undone.',
        permanentlyDeleteButton: 'Permanently Delete',
        title: 'Delete "{{name}}"?'
      },
      actionsColumn: {
        deleteButton: 'Delete',
        disableButton: 'Disable',
        enableButton: 'Enable'
      }
    }
  },
  title: 'Equipment'
};